import { render, staticRenderFns } from "./UpdateProofOfAddressAttachYourDocument.vue?vue&type=template&id=67a54b4e&"
import script from "./UpdateProofOfAddressAttachYourDocument.vue?vue&type=script&lang=ts&"
export * from "./UpdateProofOfAddressAttachYourDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
